/*! @pentacode/ui v0.1.0 */
import { i as e, n as t, s as n, t as r } from "../../shared-D0HMDGlg.js";
import { i, n as a, t as o } from "../../polar-DKgYPero.js";
import { r as s } from "../../scene-Bdst6a-n.js";
import { r as c } from "../../theme-BfnA-mmC.js";
//#region src/charts/presets/breakdown.ts
function l(l, { format: u = n, legend: d = !0, highlight: f } = {}) {
	let p = l.filter((e) => e.value > 0).sort((e, t) => t.value - e.value), m = p.reduce((e, t) => e + t.value, 0), h = e(p.map((e) => e.label), r(p), d, f);
	return s({
		theme: c,
		marks: [o({
			inset: 8,
			radiusRatio: .82,
			scales: {
				angle: null,
				radius: null
			},
			marks: [a(i(p, { value: "value" }), {
				innerRadius: ({ radius: e }) => e * .62,
				cornerRadius: 3,
				padAngle: () => .01,
				color: "label",
				key: "label"
			})]
		})],
		scales: {
			x: null,
			y: null
		},
		color: h,
		tooltip: t(u, m)
	});
}
//#endregion
export { l as breakdownChart };

//# sourceMappingURL=breakdown.js.map